import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "presets-container w-full overflow-x-scroll"
}
const _hoisted_2 = { class: "flex gap-2 items-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500 font-light"
}
const _hoisted_4 = {
  key: 0,
  class: "text-gray-400 group-hover:text-gray-500 transition-colors"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex justify-between items-start w-full mb-1 px-1 pt-2" }
const _hoisted_8 = { class: "text-[8px] px-1 text-center w-full leading-relaxed text-gray-500 font-medium pb-1" }
const _hoisted_9 = { class: "bg-brand-main text-[9px] py-1 text-center w-full leading-relaxed text-white font-light line-clamp-2" }
const _hoisted_10 = {
  key: 0,
  class: "absolute -right-2 -bottom-2 w-12 h-12 bg-brand-main/10 rounded-full blur-2xl"
}

import { computed, ref, watch } from "vue";
import SidebarNavigation from "../../sidebar/sidebarNavigation.vue";
import { useI18n } from "vue-i18n";
import InfoModal from "@/components/info/infoModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormPresets',
  props: {
    presets: { default: () => [] },
    activeFilters: { default: () => ({}) }
  },
  emits: ["updateFilters"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const filteredPresets = computed(() => {
  const stoneType = (props.activeFilters.type ?? props.activeFilters.stone_type) as string | undefined;
  const stoneForm = (props.activeFilters.form ?? props.activeFilters.stone_form) as string | undefined;

  const hasStoneForm = stoneForm !== undefined && stoneForm !== null && stoneForm !== "";
  const isNotBR = !!stoneForm && stoneForm !== "BR";
  const isEarthOrEmpty = !stoneType || stoneType === "earth";

  // Default behavior: show presets matching the current type
  return props.presets.filter((preset) => preset.filters.type === stoneType && preset.forms.includes(stoneForm));
});

const isPresetActive = (presetFilters: any) => {
  return Object.entries(presetFilters).every(([key, value]) => {
    const activeValue = props.activeFilters[key];
    if (Array.isArray(value) && Array.isArray(activeValue)) {
      return value.length === activeValue.length && value.every(v => activeValue.includes(v));
    }
    return activeValue === value;
  });
};

const activePreset = computed(() => {
  return filteredPresets.value.find(preset => isPresetActive(preset.filters));
});

const anyPresetActive = computed(() => !!activePreset.value);

const isOpen = ref(true);
const isExpanded = computed(() => anyPresetActive.value || isOpen.value);

const toggleOpen = () => {
  if (anyPresetActive.value) return;
  isOpen.value = !isOpen.value;
};

const applyPreset = (presetFilters: any) => {
  const newFilters = { ...props.activeFilters, ...presetFilters };
  emit('updateFilters', newFilters);
};

const itemRefs = ref<HTMLElement[]>([]);
const scrollContainer = ref<HTMLElement | null>(null);
const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = itemRefs.value[index];
  if (el && scrollContainer.value) {
    const container = scrollContainer.value;
    const elLeft = el.offsetLeft;
    const elWidth = el.clientWidth;
    const containerWidth = container.clientWidth;
    const targetScrollLeft = elLeft - (containerWidth / 2) + (elWidth / 2);
    container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  }
};

watch(activePreset, (preset) => {
  if (!preset) return;
  const idx = filteredPresets.value.indexOf(preset);
  if (idx >= 0) manualIndex.value = idx;
}, { immediate: true });

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  itemRefs.value.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

return (_ctx: any,_cache: any) => {
  return (filteredPresets.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "flex justify-between items-center cursor-pointer group",
          onClick: toggleOpen
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-bold text-sm text-gray-900 tracking-tight" }, "Diamant Empfehlungen:", -1)),
            (activePreset.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + activePreset.value.qualityKey + '.title')), 1))
              : _createCommentVNode("", true),
            _createVNode(InfoModal, {
              id: "stonePreset",
              value: __props.activeFilters.type
            }, null, 8, ["value"])
          ]),
          (!anyPresetActive.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': isExpanded.value }]),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ]))], 2))
              ]))
            : _createCommentVNode("", true)
        ]),
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                ref_key: "scrollContainer",
                ref: scrollContainer,
                class: "mt-4 flex flex-nowrap gap-3 overflow-x-auto no-scrollbar pb-4 scroll-smooth w-full",
                onScroll: onScroll
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPresets.value, (preset, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: preset.qualityKey,
                    ref_for: true,
                    ref: el => { if (el) itemRefs.value[index] = el as any },
                    onClick: ($event: any) => (applyPreset(preset.filters)),
                    type: "button",
                    class: _normalizeClass(["shrink-0 w-[85px] justify-between flex flex-col cursor-pointer items-start p-0 rounded-xl border transition-all duration-300 text-left group relative overflow-hidden", isPresetActive(preset.filters)
            ? 'border-brand-main bg-brand-main/5 ring-1 ring-brand-main'
            : 'border-gray-100 bg-white hover:border-brand-main/50 hover:shadow-md'])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["w-full text-center text-sm font-bold tracking-tight", isPresetActive(preset.filters) ? 'text-brand-main' : 'text-gray-900'])
                      }, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + preset.qualityKey + '.title')), 3)
                    ]),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + preset.qualityKey + '.description')), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + preset.qualityKey + '.flag')), 1),
                    (isPresetActive(preset.filters))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_6))
                }), 128))
              ], 544),
              _createVNode(SidebarNavigation, {
                total: filteredPresets.value.length,
                modelValue: currentIndex.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentIndex).value = $event)),
                container: scrollContainer.value
              }, null, 8, ["total", "modelValue", "container"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})